import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import pt from './locales/pt.json';
// Idiomas adicionais desativados temporariamente (mantidos no repo para reativação futura)
// import en from './locales/en.json';
// import es from './locales/es.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
    },
    lng: 'pt',
    fallbackLng: 'pt',
    supportedLngs: ['pt'],
    interpolation: {
      escapeValue: false,
    },
  });

// Força PT-BR mesmo se houver preferência salva antiga (en/es)
try {
  const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('i18nextLng') : null;
  if (saved && saved !== 'pt') localStorage.setItem('i18nextLng', 'pt');
} catch {}

export default i18n;
